import { MenuList as MuiMenuList, styled } from "@mui/material";
const MenuList = styled(MuiMenuList, {
  slot: "MenuList"
})(() => ({
  maxHeight: 300,
  overflowX: "hidden",
  overflowY: "auto",
  pointerEvents: "all"
}));
export {
  MenuList
};
//# sourceMappingURL=MenuList.js.map
